import React, { useState } from "react";
import "./AvailHotelCard.scss";
import CustomButton from "../../components/CustomButton";
import { handlePayment } from "../../utils/payment";
import { useMain } from "../../contexts/MainContext";
import {
  handleCancelHotelBookingApiCall,
  handleHotelPaymentApiCall,
} from "../../utils/ApiCalls";
import {
  formatDate,
  getCurrentDate,
  getCurrentTime,
} from "../../shared/sharedFunctions";
import { CANCELED, UPCOMING } from "../../constants/stringConstants";
import ConformPopUp from "../ConformPopUp";

const AvailHotelCard = ({
  data,
  resultForData,
  handleUpdateHotelCount,
  isHotelBookingListPage,
  filterBtn,
  handleRemoveHotelBooking,
}) => {
  const { hotel } = data;
  const mainContext = useMain();
  const [confirmPopUp, setConfirmPopUp] = useState({
    visible: false,
    deleteId: null,
  });
  const handleHotelPaymentCallback = (response) => {
    console.log("payment res", response?.razorpay_payment_id);
    if (response?.razorpay_payment_id) {
      const date = new Date();
      const dataObj = {
        userId: mainContext?.loginDetails?.userId,
        hotelId: hotel?.hotelId,
        hotelRoomId: data?.hotelRoomId,
        razorpayPaymentId: response?.razorpay_payment_id,
        checkInDate: resultForData?.checkIn,
        checkOutDate: resultForData?.checkOut,
        adultCount: resultForData?.adultCount,
        childrenCount: resultForData?.childrenCount,
        roomCount: resultForData?.roomCount,
        paymentStatus: true,
        // bookedDate: `${date.getFullYear()}-${
        //   date.getMonth() < 10 ? "0" : ""
        // }${date.getMonth()}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}`,
        // bookedTime: `${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${
        //   date.getMinutes() < 10 ? "0" : ""
        // }${date.getMinutes()}`,
        bookedDate: getCurrentDate(),
        bookedTime: getCurrentTime(),
        paymentAmount: data?.price,
      };
      console.log(dataObj, date.getFullYear());
      const resp = handleHotelPaymentApiCall(dataObj);
      resp.then((res) => {
        console.log(res);
        alert("Payment Successful !!!");
        handleUpdateHotelCount(resultForData?.roomCount);
      });
    } else {
      alert("Payment Faild");
    }
  };

  const handleCancelBtnClick = () => {
    const response = handleCancelHotelBookingApiCall(
      data?.hotelBookingRecordId
    );
    response.then((res) => {
      if (res?.status === 200) {
        alert(res?.data);
        handleRemoveHotelBooking();
      }
    });
  };

  const handleDeleteBtnClick = () => {
    setConfirmPopUp((prevState) => {
      return {
        ...prevState,
        visible: true,
      };
    });
  };

  const onConfirm = () => {
    handleCancelBtnClick();
    setConfirmPopUp({
      ...confirmPopUp,
      visible: false,
      deleteId: null,
    });
  };

  const onCancel = () => {
    setConfirmPopUp({
      ...confirmPopUp,
      visible: false,
      deleteId: null,
    });
  };
  return (
    <>
      <div className="AvailHotelCard">
        <div className="AvailHotelCard__content-wrapper">
          <div className="wrapper_1">
            <img
              src={hotel?.coverImg?.mediaUrl}
              className="hotel-img"
              width="300"
              alt="hotel-img"
            />
            <div className="hotel_content">
              <div className="hotel_name_wrapper">
                <h2>{hotel?.hotelName}</h2>
                {!isHotelBookingListPage && (
                  <p className="avil_count_text">{`(Avil:${data?.currentAvailCount})`}</p>
                )}
              </div>
              <div className="hotel_content-wrapper">
                <div className="content-1">
                  {/* <p>rating 4.5</p> */}
                  <p>{`${hotel?.city}, ${hotel?.state}, ${hotel?.country}`}</p>
                  <div className="desc-wrapper">
                    <p className="heading">Description</p>
                    <p>{hotel?.description}</p>
                  </div>
                </div>
                <div className="content-2">
                  <p className="heading">Top amenities</p>
                  <div className="rules-list-wrapper">
                    {hotel.married && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">
                          partner_exchange
                        </span>
                        <p>Married</p>
                      </div>
                    )}
                    {hotel.unmarried && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">person</span>
                        <p>Unmarried</p>
                      </div>
                    )}
                    {hotel.smoking && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">
                          smoking_rooms
                        </span>
                        <p>Smoking</p>
                      </div>
                    )}
                    {hotel.drinking && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">liquor</span>
                        <p>Drinking</p>
                      </div>
                    )}
                    {hotel.wifi && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">wifi</span>
                        <p>Wifi</p>
                      </div>
                    )}
                    {hotel.water && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">
                          water_drop
                        </span>
                        <p>Water</p>
                      </div>
                    )}
                    {hotel.food && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">
                          restaurant
                        </span>
                        <p>Food</p>
                      </div>
                    )}
                    {hotel.electricity && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">bolt</span>
                        <p>Electricity</p>
                      </div>
                    )}
                    {hotel.gym && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">exercise</span>
                        <p>Gym</p>
                      </div>
                    )}
                    {hotel.pet && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">pets</span>
                        <p>Pets</p>
                      </div>
                    )}
                    {data.airConditioner && (
                      <div className="hotel-rule">
                        <span class="material-symbols-outlined">ac_unit</span>
                        <p>AC</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!isHotelBookingListPage ? (
            <div className="hotel_book_now">
              <div className="book_content">
                <p className="price">{`Price: Rs.${data?.price}`}</p>
                <CustomButton
                  type="add"
                  value="Book Now"
                  onClick={() => {
                    handlePayment(
                      Number(data?.price),
                      handleHotelPaymentCallback
                    );
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="booking_details_container">
              <div className="detail_wrapper">
                <p className="heading">Booking Details</p>
                <p>{`Adult: ${data?.adultCount}`}</p>
                <p>{`Children: ${data?.childrenCount}`}</p>
                <p>{`Room: ${data?.roomCount}`}</p>
                <p>{`${formatDate(data?.checkInDate)} | ${formatDate(
                  data?.checkOutDate
                )}`}</p>
                <p>{`Paid Amount: Rs.${data?.paymentAmount}`}</p>
              </div>
              {filterBtn === UPCOMING && (
                <CustomButton
                  type="delete"
                  value="Cancel"
                  onClick={handleDeleteBtnClick}
                />
              )}
              {filterBtn === CANCELED && (
                <p className="canceled_text">Canceled</p>
              )}
            </div>
          )}
        </div>
      </div>
      {confirmPopUp.visible && (
        <ConformPopUp
          description="Are you sure to cancel!"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      )}
    </>
  );
};

export default AvailHotelCard;
